import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth-context";

// Handles Emergent OAuth redirect: reads #session_id, exchanges with backend,
// then redirects to the appropriate dashboard.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    // clean fragment quickly
    window.history.replaceState({}, document.title, window.location.pathname);

    api
      .post("/auth/google/session", { session_id: sid })
      .then(({ data }) => {
        setUser(data);
        toast.success(`Signed in as ${data.name || data.email}`);
        navigate(data.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      })
      .catch((err) => {
        const msg = formatApiError(err);
        setError(msg);
        toast.error(msg);
        setTimeout(() => navigate("/login", { replace: true }), 2000);
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-background" data-testid="auth-callback">
      {error ? (
        <p className="text-sm text-destructive">{error}</p>
      ) : (
        <div className="flex items-center gap-3 text-sm text-muted-foreground">
          <Loader2 className="w-5 h-5 animate-spin text-cyan-400" />
          Completing sign in…
        </div>
      )}
    </div>
  );
}
